// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"d3475167","44":"9defe290","84":"9a2822bc","133":"122f6cb7","299":"155e2e86","302":"25b572a2","399":"a9b3342a","453":"2dc8a369","532":"2114bce8","569":"0f8cd327","714":"e31e26b8","809":"1d3c304a","936":"85cf7567"}[chunkId] + ".chunk.js";
};